var RouterConstants = {
    MANAGE_PRODUCT: '/manage-product',
    OPEN_PLATFORM_CATEGORIES: '/openplatform-categories/',
    OPEN_PLATFORM_BRANDS: '/openplatform-brands/',
    ACCESS_DENIED: '/access-denied',
    NOT_ACCEPTABLE:'/not-acceptable'
}
export default RouterConstants;